import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import config from "../../config";

const Login = ({ setIsLoggedIn }) => {
  // Accept setIsLoggedIn as prop
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate(); // Initialize useNavigate

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Make a POST request to the backend login route
      const response = await fetch(`${config.apiBaseUrl}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email_id: email, password }),
      });

      const data = await response.json();

      console.log("Login Data ", data);

      if (response.ok) {
        console.log("Login successful:", data);
        // Store accessToken and refreshToken data in local storage
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("email", data?.user?.email);
        localStorage.setItem("role", data?.user?.role);
        // Update isLoggedIn state
        setIsLoggedIn(true);

        // if login success then remove redirectTo
        if (localStorage.getItem("redirectTo") == "/login") {
          console.log("Removed:", localStorage.getItem("redirectTo"));
          localStorage.removeItem("redirectTo");
        }

        const role = localStorage.getItem("role");

        // Retrieve the redirectTo URL from localStorage or fallback to dashboard
        // const redirectTo =
        //   localStorage.getItem("redirectTo") || "/user/dashboard";
        // localStorage.removeItem("redirectTo"); // Clear redirectTo after using it

        let redirectTo;

        if (role === "moderator") {
          redirectTo = "/user/moderate";
        } else {
          // Retrieve the redirectTo URL from localStorage or fallback to dashboard
          redirectTo = localStorage.getItem("redirectTo") || "/user/dashboard";
        }

        localStorage.removeItem("redirectTo"); // Clear redirectTo after using it

        // Redirect to the appropriate page
        navigate(redirectTo);
      } else {
        setErrorMessage(data.message); // Display error message if login fails
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
      console.error("Error during login:", error);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="card log-card p-4">
        <div className="mb-4">
          <div className="text-center">
            <img
              src="/icon/main-logo-full.png"
              alt="Logo"
              className="img-fluid mb-3"
              width="140"
            />
          </div>
          <h5 className="card-title log-title">
            Welcome Back to Big Screen Social
          </h5>
          <p className="text-muted">
            Please enter your credentials to log in to your account.
          </p>
        </div>
        <form onSubmit={handleLogin} className="text-start">
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email address
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="rememberMe"
            />
            <label className="form-check-label" htmlFor="rememberMe">
              Remember me
            </label>
          </div>
          <button type="submit" className="btn w-100 theme-button">
            Login
          </button>
          {errorMessage && (
            <div className="text-danger mt-2">{errorMessage}</div>
          )}{" "}
          {/* Display error message */}
        </form>
      </div>
    </div>
  );
};

export default Login;
